import { motion } from "framer-motion";

const Stencil: React.FC = () => {
    const draw = {
        hidden: { pathLength: 0, opacity: 0 },
        visible: (i: number) => ({
            pathLength: 1,
            opacity: 1,
            transition: {
                pathLength: {
                    delay: i * 0.5,
                    type: "ease",
                    duration: 40,
                    bounce: 0,
                },
                opacity: { delay: i * 0.25, duration: 0.01 },
            },
        }),
    };
    const draw2 = {
        hidden: { pathLength: 0, opacity: 0 },
        visible: (i: number) => ({
            pathLength: 1,
            opacity: 1,
            transition: {
                pathLength: {
                    delay: i * 0.25,
                    type: "ease",
                    duration: 3,
                    bounce: 0,
                },
                opacity: { delay: i * 0.25, duration: 0.01 },
            },
        }),
    };
    return (
        <motion.svg
            id='Layer_2'
            data-name='Layer 2'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 1965 332.37'
            initial='hidden'
            whileInView='visible'
        >
            <defs>
                <style>
                    {`
      .cls-10 {
        fill: none;
        stroke: #283583;
        stroke-miterlimit: 10;
      }`}
                </style>
            </defs>
            <motion.g id='Layer_1-2' data-name='Layer 1'>
                <g>
                    <motion.rect
                        className='cls-10'
                        x='189.04'
                        y='310.1'
                        width='213.09'
                        height='21.77'
                        variants={draw2}
                        custom={0}
                    />
                    <motion.path
                        className='cls-10'
                        d='m1880.1,78.09V29.07h81.67V3.22h-108.89v190.56h111.62v-25.86h-84.4v-63.98h62.62v-25.86h-62.62Zm-206.59-49.01h51.73v164.7h27.22V29.07h51.73V3.22h-130.67v25.86Zm-99.17,19.07l29.4,70.78h-58.81l29.4-70.78Zm60.17,145.64h28.31L1583.86,3.22h-19.07l-78.94,190.56h28.31l19.87-49h80.32l20.15,49Zm-187.11-115.69h-81.67v25.86h54.46v49c-10.07,10.07-26.69,17.7-46.84,17.7-40.56,0-71.59-29.13-71.59-72.14s30.21-72.14,69.15-72.14c20.41,0,40.28,9.26,51.45,21.51l18.24-17.97c-16.6-18.24-42.47-29.39-69.69-29.39-55,0-96.38,43.01-96.38,98s41.92,98.01,98.81,98.01c29.4,0,57.71-14.7,74.05-35.39v-83.03Zm-341.16,86.56c16.88,20.43,40.56,31.86,66.69,31.86,33.22,0,59.07-21.78,59.07-55.26,0-21.78-11.97-35.13-24.78-43.57-24.5-16.32-65.06-21.51-65.06-45.73,0-16.61,15.78-25.59,31.58-25.59,11.97,0,23.68,4.35,34.03,13.07l16.06-19.87c-10.07-8.44-26.95-19.05-51.19-19.05-33.22,0-57.71,22.86-57.71,50.63,0,19.87,10.63,32.94,24.24,41.92,25.32,16.61,65.61,19.87,65.61,49.01,0,17.14-15.52,28.57-33.22,28.57-19.61,0-35.39-10.88-46.56-24.5l-18.78,18.51Zm-96.97-55.26c18.51,0,30.49-4.63,39.74-12.53,11.43-9.8,18.79-24.22,18.79-40.56s-7.36-30.76-18.79-40.56c-9.26-7.9-21.23-12.53-39.74-12.53h-72.14v190.56h27.22v-84.39h44.92Zm-44.92-25.86V29.07h43.57c13.07,0,20.13,3.27,25.04,8.44,4.63,4.91,7.62,11.45,7.62,18.79s-2.99,13.88-7.62,18.79c-4.91,5.17-11.97,8.44-25.04,8.44h-43.57Zm-248.39,14.97c0-41.1,29.13-72.14,68.07-72.14s68.05,31.04,68.05,72.14-29.13,72.14-68.05,72.14-68.07-30.76-68.07-72.14m-27.22,0c0,55.54,41.38,98.01,95.28,98.01s95.28-42.47,95.28-98.01S837.91.5,784,.5s-95.28,42.46-95.28,98m-84.92,95.28h27.23V3.22h-27.23v74.87h-106.17V3.22h-27.23v190.56h27.23v-89.84h106.17v89.84Zm-320.21-21.77c16.61,16.6,35.67,24.5,57.71,24.5,38.4,0,70.24-28.31,70.24-65.89,0-20.41-9.26-39.74-24.22-51.71-13.34-10.89-29.68-14.44-44.38-14.44-5.17,0-10.89.55-14.7,1.37l3.01-29.95h70.78V3.22h-100.74l-12.25,101,22.88,3.27c8.16-6.82,18.78-10.35,28.03-10.35s17.16,2.45,23.14,7.62c7.36,6.26,11.71,15.52,11.71,25.86s-4.09,18.51-10.61,24.51c-6.26,5.71-14.44,8.7-22.88,8.7-12.79,0-24.5-6.53-32.66-15.24l-25.05,23.42Zm-94.55,21.77h39.98V3.22h-39.98v190.56Zm-115.04,0c19.33,0,31.84-4.63,41.65-12.79,12.79-10.35,20.95-26.41,20.95-44.11,0-21.51-13.33-41.1-31.3-50.09,8.98-8.44,14.98-20.95,14.98-34.02,0-14.16-6-27.23-15.8-36.21-8.98-8.18-20.69-13.34-39.2-13.34H.5v190.56h73.51ZM27.73,78.09V29.07h32.67c15.24,0,21.77,3.01,26.13,7.9,4.07,4.36,6.53,10.07,6.53,16.61s-2.45,12.25-6.53,16.6c-4.36,4.91-10.89,7.9-26.13,7.9H27.73Zm0,89.84v-63.98h41.38c17.16,0,25.32,3.81,31.32,9.8,5.43,5.72,8.98,13.34,8.98,22.06s-3.55,16.6-8.98,22.32c-6,5.99-14.16,9.8-31.32,9.8H27.73Z'
                        variants={draw}
                        custom={0}
                    />
                </g>
            </motion.g>
        </motion.svg>
    );
};

export default Stencil;
